var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col gap-4"},[_c('div',{staticClass:"flex flex-col gap-1"},[_c('mdn-text',{staticClass:"text-xs font-bold"},[_vm._v(_vm._s(_vm.name))]),_c('mdn-text',{staticClass:"text-xs text-gray-700"},[_vm._v(_vm._s(_vm.description))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }